import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5e037f4d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5e037f4d&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e037f4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e037f4d')) {
      api.createRecord('5e037f4d', component.options)
    } else {
      api.reload('5e037f4d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5e037f4d&scoped=true", function () {
      api.rerender('5e037f4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm_fine/views/activity_center/components/additional/index.vue"
export default component.exports